import { ITEM_TYPES } from '../types/ItemTypes';
export function getUserPatternByItemType(userPatternsArray, itemType) {
    if (userPatternsArray === void 0) { userPatternsArray = []; }
    if (itemType === void 0) { itemType = ITEM_TYPES.STATIC_PAGE_V2; }
    try {
        var userPatternContent = (userPatternsArray.find(function (_a) {
            var patternType = _a.patternType;
            return patternType === itemType;
        }) ||
            {}).content || {};
        if (typeof userPatternContent === 'string') {
            return JSON.parse(userPatternContent);
        }
        return userPatternContent;
    }
    catch (e) {
        return {};
    }
}
